import React, { useState } from "react";
import ManagementHeader from "../components/common-managment/ManagementHeader";
import build from "../../src/assets/icons/build-white.svg";
import category from "../assets/icons/category_search.svg";
import add from "../assets/icons/add.svg";
import remove from "../assets/icons/delete.svg";
import TableData from "../components/project-management/TableData";
import toast from "react-hot-toast";
import CategoryManagement from "../components/project-management/CategoryManagement";

export default function ProjectManagement() {
  const [addRowForm, setAddRowForm] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [newData, setNewData] = useState({
    project_name: "승강기",
    start_date: "2025-09-15",
    end_date: "2025-10-15",
    description: "프로젝트 설명",
    tab: "I3D",
    dev_type: ["IIS"],
    url: "www.sgg.co.kr",
    representative_image: null,
    related_documents: null,
    related_video: null,
  });
  const [rows, setRows] = useState([
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
    {
      project_name: "승강기",
      start_date: "2025-09-15",
      end_date: "2025-10-15",
      description: "프로젝트 설명",
      tab: "I3D",
      dev_type: ["IIS"],
      url: "www.sgg.co.kr",
      representative_image: null,
      related_documents: null,
      related_video: null,
    },
  ]);

  // ✅ handle save
  const handleSave = () => {
    setRows((prev) => [...prev, { ...newData }]);
    toast.success("Project saved successfully!");
    setAddRowForm(false);
  };

  const handleSelectedRowsDelete = () => {
    // remove selected rows
    setRows((prev) => prev.filter((_, idx) => !selectedRows.includes(idx)));
    setSelectedRows([]); // clear selection
    toast.success("Project Delete successfully!");
  };

  // popup
  const [openCategoryManagementPopup, setOpenCategoryManagementPopup] =
    useState(false);

  return (
    <main className="bg-[#262d44] !pt-0 p-4 sm:p-[30px] flex flex-col h-screen">
      <ManagementHeader />
      <div className="flex-1 bg-[#323649] rounded-[10px] md:rounded-[16px] overflow-hidden flex flex-col">
        {/* top bar  */}
        <div className="bg-[#44495F] sm:py-2 px-4 sm:pr-2.5 py-4 flex items-center flex-wrap gap-4 justify-between shadow-[0_20px_40px_0_rgba(15,_17,_26,_0.20)] ">
          {/* left side  */}
          <div className="flex items-center gap-2.5">
            <img src={build} alt="" />
            <h4 className="text-white font-medium text-[18px]">
              프로젝트 관리
            </h4>
          </div>

          {/* right side  */}
          <div className="flex items-center gap-2.5">
            <button
              onClick={() => setOpenCategoryManagementPopup(true)}
              className="p-2.5 bg-[#232633] rounded-[6px] w-[75px] h-8 flex items-center justify-center"
            >
              <img src={category} alt="" />
            </button>
            <button
              onClick={() => setAddRowForm(true)}
              className="p-2.5 bg-[#232633] rounded-[6px] w-[75px] h-8 flex items-center justify-center"
            >
              <img src={add} alt="" />
            </button>
            <button
              onClick={handleSelectedRowsDelete}
              className="p-2.5 bg-[#232633] rounded-[6px] w-[75px] h-8 flex items-center justify-center disabled:cursor-not-allowed"
              disabled={selectedRows.length === 0}
            >
              <img src={remove} alt="" />
            </button>
          </div>
        </div>

        {/* table data  */}
        <TableData
          rows={rows}
          setRows={setRows}
          newData={newData}
          setNewData={setNewData}
          handleSave={handleSave}
          addRowForm={addRowForm}
          setAddRowForm={setAddRowForm}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
        />
      </div>

      {/* Category Management popup  */}
      <CategoryManagement
        setOpenCategoryManagementPopup={setOpenCategoryManagementPopup}
        openCategoryManagementPopup={openCategoryManagementPopup}
      />
    </main>
  );
}
